import React from "react";

export function useRolesPageModalsState() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [newRoleName, setNewRoleName] = React.useState("");
  const [newRoleEmployee, setNewRoleEmployee] = React.useState(false);
  const [selectedPerms, setSelectedPerms] = React.useState<string[]>([]);

  const [isEditOpen, setIsEditOpen] = React.useState(false);
  const [editRoleId, setEditRoleId] = React.useState<number | null>(null);
  const [editRoleName, setEditRoleName] = React.useState("");
  const [editRoleEmployee, setEditRoleEmployee] = React.useState(false);
  const [editSelectedPerms, setEditSelectedPerms] = React.useState<string[]>([]);

  const resetCreateModal = React.useCallback(() => {
    setIsOpen(false);
    setNewRoleName("");
    setNewRoleEmployee(false);
    setSelectedPerms([]);
  }, []);

  const resetEditModal = React.useCallback(() => {
    setIsEditOpen(false);
    setEditRoleId(null);
    setEditRoleName("");
    setEditRoleEmployee(false);
    setEditSelectedPerms([]);
  }, []);

  return {
    isOpen,
    setIsOpen,
    newRoleName,
    setNewRoleName,
    newRoleEmployee,
    setNewRoleEmployee,
    selectedPerms,
    setSelectedPerms,
    isEditOpen,
    setIsEditOpen,
    editRoleId,
    setEditRoleId,
    editRoleName,
    setEditRoleName,
    editRoleEmployee,
    setEditRoleEmployee,
    editSelectedPerms,
    setEditSelectedPerms,
    resetCreateModal,
    resetEditModal,
  };
}
